var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "activitiesEdit",
      attrs: { title: "编辑", visible: _vm.visible, width: "68%" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, size: "mini" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-form-item", { attrs: { label: "活动名称：" } }, [
                    _vm._v(_vm._s(_vm.form.name)),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-form-item", { attrs: { label: "活动状态：" } }, [
                    _vm._v(_vm._s(_vm.form.status)),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-form-item", { attrs: { label: "创建人：" } }, [
                    _vm._v(_vm._s(_vm.form.auditorName)),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "创建时间：" } }, [
                    _vm._v(_vm._s(_vm.form.auditTime)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动时间：" } },
                [
                  _c("avue-date", {
                    attrs: {
                      type: "datetimerange",
                      prop: "datetimerange",
                      format: "yyyy-MM-dd HH:mm:ss",
                      valueFormat: "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.handleSelectDate },
                    model: {
                      value: _vm.dates,
                      callback: function ($$v) {
                        _vm.dates = $$v
                      },
                      expression: "dates",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("el-form-item", { attrs: { label: "参与供应商：" } }, [
                _vm._v(_vm._s(_vm.form.merchantName)),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("el-form-item", { attrs: { label: "可用线路：" } }, [
                _vm._v(_vm._s(_vm.form.lineName)),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动奖励：" } },
                [
                  _vm._v("\n        减 "),
                  _c("el-input", {
                    staticStyle: { width: "6vw" },
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.form.discountsMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "discountsMoney", $$v)
                      },
                      expression: "form.discountsMoney",
                    },
                  }),
                  _vm._v(" 元\n      "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("el-form-item", { attrs: { label: "是否可使用优惠券：" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.form.isChooseCoupon === 0 ? "否" : "是") +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("el-form-item", { attrs: { label: "互斥：" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.form.isUserCoupon === 0 ? "否" : "是") +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.submit },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }